import { PageContainer } from '@if/mui'
import DevToolsMain from '@src/components/Admin/DevTools/DevToolsMain'
import { useTranslation } from 'react-i18next'

const DevToolsPage = () => {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('admin.devTools.pageTitle')} subtitle={t('admin.devTools.subtitle')}>
      <DevToolsMain />
    </PageContainer>
  )
}

export default DevToolsPage
